import { colorSet } from '@components/Provider';
import { makeStyles, Theme } from '@material-ui/core';

interface Props {
  matches?: boolean;
}

export const useStyles = makeStyles((theme) => ({
  container: {
    maxWidth: 600,
    width: '100%',
    margin: 'auto',

    [theme.breakpoints.down('md')]: {
      maxWidth: '100%'
    },
    '& .MuiDivider-root': {
      height: 1,
      width: '100%',
      maxWidth: 552,
      background: colorSet.gray400,
      margin: 'auto',
      [theme.breakpoints.down('md')]: {
        maxWidth: '100%',
        width: '100%',
        height: 16,
        background: colorSet.gray200
      }
    },
    '& .item': {
      padding: '32px 24px',
      [theme.breakpoints.down('md')]: {
        padding: '32px 16px'
      }
    }
  }
}));
export const useStylesCommon = makeStyles<Theme, Props>(() => {
  return {
    root: {},
    wordBreak: {
      wordBreak: 'unset',
      whiteSpace: 'pre-line'
    },
    imageViewer: {
      borderBottom: 'none'
    }
  };
});
